var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.jpg")}}),_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" Hi again from the other side ... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }